import React from 'react';

import {StorableRelevantItemsGraphQL} from 'relevant-items/storables/__generated/StorableRelevantItemsGraphQL';
import {useStorableRelevantItemsFilteredTableState} from 'relevant-items/storables/StorableRelevantItemsFilteredTableState';
import StorableRelevantItemsSectionHeader from 'relevant-items/storables/StorableRelevantItemsSectionHeader';
import StorableRelevantItemsSectionTable from 'relevant-items/storables/StorableRelevantItemsSectionTable';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface StorablePresentationalRelevantItemsSectionProps {
  relevantItemsGraphQL: StorableRelevantItemsGraphQL;
  storableId: string;
  /** @default false */
  isCompact?: boolean;
  /** @default 100 */
  paginationLimit?: number;
}

export default function StorablePresentationalRelevantItemsSection({
  relevantItemsGraphQL,
  storableId,
  isCompact,
  paginationLimit,
}: StorablePresentationalRelevantItemsSectionProps): JSX.Element {
  const [filteredTableState, updateFilteredTableState] =
    useStorableRelevantItemsFilteredTableState(storableId);

  return (
    <div {...getTestProps({component: 'StorablePresentationalRelevantItemsSection', element: 'root'})}>
      <StorableRelevantItemsSectionHeader
        filteredTableState={filteredTableState}
        updateFilteredTableState={updateFilteredTableState}
        storableId={storableId}
      />

      <StorableRelevantItemsSectionTable
        relevantItemsGraphQL={relevantItemsGraphQL}
        filteredTableState={filteredTableState}
        updateFilteredTableState={updateFilteredTableState}
        storableId={storableId}
        isCompact={isCompact}
        paginationLimit={paginationLimit}
      />
    </div>
  );
}
